import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import {Box, CardContent, CardHeader, Typography} from '@mui/material'
import Card from '@mui/material/Card'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import {blue} from '@mui/material/colors'
import {useNavigate} from 'react-router-dom'

function createData(feature: string, free: any, single: any, standard: any, premium: any) {
  return {feature, free, single, standard, premium}
}

const rows = [
  createData(
    'Personal Profile Management',
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />
  ),
  createData(
    'Business Profile Management',
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />
  ),
  createData(
    'Business and People Directory Keyword Search',
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />
  ),
  createData(
    'AI search with custom-tailored graph concepts',
    <></>,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />
  ),
  createData(
    'Opportunity Notifications',
    <>
      {' '}
      <CheckCircleIcon fontSize={'small'} />
    </>,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />
  ),
  createData(
    'Track Favorite Businesses and Profiles',
    <></>,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />
  ),
  createData(
    'Projects for Scouting Evaluations',
    <></>,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />
  ),

  createData(
    'Add Notes and Documents to Projects and Entities',
    <></>,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />
  ),
  createData(
    'View Projects',
    <>
      {' '}
      <CheckCircleIcon fontSize={'small'} />
    </>,
    <></>,
    <>
      <CheckCircleIcon fontSize={'small'} />
    </>,
    <>
      <CheckCircleIcon fontSize={'small'} />
    </>
  ),
  createData(
    'Create & Share Projects',
    <></>,
    <></>,
    <>
      <CheckCircleIcon fontSize={'small'} />
    </>,
    <>
      <CheckCircleIcon fontSize={'small'} />
    </>
  ),
  createData(
    'Customer Support',
    <></>,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />
  ),
  createData('Personalized Training', <></>, <></>, <></>, <CheckCircleIcon fontSize={'small'} />),
  createData(
    'Scouting Exericse Support',
    <></>,
    <></>,
    <></>,
    <CheckCircleIcon fontSize={'small'} />
  ),
  createData(
    'Semi-Annual Improvement program',
    <></>,
    <></>,
    <></>,
    <CheckCircleIcon fontSize={'small'} />
  ),
  createData(
    'Technical Assistance/training needs',
    <></>,
    <></>,
    <></>,
    <CheckCircleIcon fontSize={'small'} />
  ),
  createData(
    'New Features and Upgrades',
    <></>,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />,
    <CheckCircleIcon fontSize={'small'} />
  ),
  createData(
    'Customer Success Specialist',
    <></>,
    <></>,
    <></>,
    <CheckCircleIcon fontSize={'small'} />
  ),
]

export default function UpgradePricingTable({
  currentPlan,
  elevation,
}: {
  currentPlan?: string
  elevation?: boolean
}) {
  const navigate = useNavigate()
  return (
    <Card elevation={elevation ? 1 : 0} sx={{flex: '1', p: 1, pt: 0, mt: 0, mr: 1}}>
      <CardHeader
        title={
          <Box display={'flex'} justifyContent={'space-between'}>
            <Typography variant={'h6'} fontWeight={700}>
              iScout Subscription Plan Features
            </Typography>
            {/* <Button variant='contained' onClick={() => navigate('/ecoplans')}>
              Explore Plans for Ecosystems and Communities
            </Button>{' '} */}
          </Box>
        }
      ></CardHeader>
      <CardContent>
        <Table size={'small'}>
          <TableBody>
            <TableRow sx={{flex: '1', alignContent: 'center', alignItems: 'center'}}>
              <TableCell align='left' width={'25%'}>
                <Typography variant={'h6'}>Features</Typography>
              </TableCell>
              <TableCell align='center' width={'15%'}>
                {(!currentPlan || currentPlan === 'free') && (
                  <Typography color={blue[600]}>(Current Plan)</Typography>
                )}
                <Typography variant={'h6'} color={!currentPlan ? blue[600] : 'inherit'}>
                  Free
                </Typography>
              </TableCell>
              {/* <TableCell align='center' width={'15%'}>
                {currentPlan && <Typography color={blue[600]}>(Current Plan)</Typography>}
                <Typography variant={'h6'} color={currentPlan ? blue[600] : 'inherit'}>
                  Single User
                </Typography>
              </TableCell> */}
              <TableCell align='center' width={'15%'}>
                {currentPlan === 'standard' && (
                  <Typography color={blue[600]}>(Current Plan)</Typography>
                )}
                <Typography
                  variant={'h6'}
                  color={currentPlan === 'Standard' ? blue[600] : 'inherit'}
                >
                  Standard
                </Typography>
              </TableCell>
              <TableCell align='center' width={'15%'}>
                {currentPlan === 'Premium' && (
                  <Typography color={blue[600]}>(Current Plan)</Typography>
                )}
                <Typography
                  variant={'h6'}
                  color={currentPlan === 'premium' ? blue[600] : 'inherit'}
                >
                  Premium
                </Typography>
              </TableCell>
            </TableRow>
            {rows.map((row) => (
              <TableRow
                key={row.feature}
                sx={{
                  flex: '1',
                }}
              >
                <TableCell width={'25%'}>
                  <Typography variant={'body1'}>{row.feature}</Typography>
                </TableCell>
                <TableCell align='center' width={'15%'}>
                  <Typography variant={'body1'}>{row.free}</Typography>
                </TableCell>
                {/* <TableCell align='center' width={'15%'}>
                  <Typography variant={'body1'}>{row.single}</Typography>
                </TableCell> */}
                <TableCell align='center' width={'15%'}>
                  <Typography variant={'body1'}>{row.standard}</Typography>
                </TableCell>
                <TableCell align='center' width={'15%'}>
                  <Typography variant={'body1'}>{row.premium}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  )
}
